import { io } from 'socket.io-client'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

let socket = null
let users = 0

export function acquireChatSocket() {
  users += 1
  if (!socket) {
    socket = io(BASE_URL, { withCredentials: true, autoConnect: true })
  }
  return socket
}

export function releaseChatSocket() {
  users = Math.max(0, users - 1)
  if (users === 0 && socket) {
    socket.disconnect()
    socket = null
  }
}

export function emitChat(event, payload) {
  if (!socket) return
  socket.emit(event, payload)
}
